import { render, staticRenderFns } from "./CertificateImportDlg.vue?vue&type=template&id=4776be60&scoped=true&"
import script from "./CertificateImportDlg.vue?vue&type=script&lang=ts&"
export * from "./CertificateImportDlg.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateImportDlg.vue?vue&type=style&index=0&id=4776be60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776be60",
  null
  
)

export default component.exports